import { BaseApi } from "./BaseApi";

export interface ShippingMethodViewModel {
    id: string;
    text: string;
    name: string;
    price: number;
}

export interface BillingModel {
    userName?: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    mobilePhoneNumber?: string;
    company?: string;
    addressLine1: string;
    addressLine2?: string;
    postalCode: string;
    city: string;
    state?: string;
    attention?: string;
    countryId: number;
}

export interface BillingAndShippingModel {
    billing: BillingModel;
    shippingAsBilling: boolean;
    shipping?: BillingModel;
    note?: string;
    requisitionNo?: string;
}

export interface OrderLineModel {
    sku: string;
    quantity: number;
}

export interface ConfiguratorCheckoutModel {
    orderLines: OrderLineModel[];
    information: BillingAndShippingModel;
    shippingMethod: ShippingMethodViewModel;
    acceptUrl: string;
    cancelUrl: string;
    newsletter: boolean;
    termsUrl: string;
}

export class CheckoutApi {
    private httpClient: BaseApi;

    constructor(httpClient: BaseApi) {
        this.httpClient = httpClient;
    }

    public getShippingMethods(orderLines: OrderLineModel[]): Promise<ShippingMethodViewModel[]> {
        return this.httpClient.httpPost(
            `/api/order/getshippingmethods`,
            orderLines
        );
    }

    public initializeCheckout(model: ConfiguratorCheckoutModel): Promise<any> {
        return this.httpClient.httpPost("/api/order/initialize", model);
    }
}
